<template>
  <footer class="admin-footer">
    <div class="inner-container d-flex justify-content-between align-items-center h-100">
      <span class="text">V{{ version }}</span>
      <p class="text text-dark my-0">Forjado por <a href="https://wize.pe" target="_blank">Wize</a> &copy; {{ year }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter",
  data() {
    return {
      version: process.env.PACKAGE_VERSION,
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.admin-footer {
  height: 34px;
  font-size: 10px;
  width: 100%;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.25);
  padding: 0 41px;
}
.admin-footer .text {
  font: 500 16px Roboto, serif;
  color: #3e4657;
  font-size: 12px;
}
</style>
